/**
 * CSS VH trick for mobile
 *
 * @see    https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
const vh = window.innerHeight * 0.01;
let delayed = false;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  if (!delayed) {
    delayed = true;
    setTimeout(() => {
      delayed = false;
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, 50);
  }
});
